import { useQuery } from '@tanstack/react-query';
import type { NetworkData } from './types';

export function useNetworkData() {
  return useQuery<NetworkData>({
    queryKey: ['cartographic-results', 'network-data'],
    queryFn: async () => {
      const res = await fetch('/api/optimisations/123/cartographic-results');
      if (!res.ok) throw new Error('Failed to load network data');
      return res.json();
    },
  });
}
